export default {"src":"/login-app/[GIT_HASH]/_next/static/media/git_closed.00e81930.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};